import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, CardActions, Stack, Typography } from '@mui/material';
import { MprcCard, MprcContainer, MprcText } from 'components';
import React from 'react';

////////////////////////////////////////////////////////////////////////////

export interface MprcNoticeBlock {
    icon?: IconProp;
    iconColor?: MprcColors | [MprcColors, MprcColorVariant] | "inherit";
    title?: React.ReactNode;
    text?: React.ReactNode;
    action?: React.ReactNode;
}

interface IProps {
    elevation?: "none" | "small" | "medium";
    size?: "small" | "medium";
    items: MprcNoticeBlock[];
    disableTypography?: boolean;
}

////////////////////////////////////////////////////////////////////////////

export const MprcNotice: React.FC<IProps> = ({ size = "medium", items, disableTypography = false, elevation = "none" }) => {

    const messages = items.filter(el => Object.keys(el).length);
    const emptyItem: MprcNoticeBlock = {};

    return (
        <>
            {messages.length > 0 &&
                <MprcContainer>
                    <MprcCard paperColor="notice" elevation={elevation == "none" ? 0 : elevation === "small" ? 1 : 2}>
                        <Box sx={{ py: 1, px: 2 }}>
                            {
                                messages.filter(p => p != emptyItem).map(
                                    (item, index) =>
                                        <MprcContainer key={index} margin={messages.length == index + 1 ? "none" : "dense"}>
                                            <Stack direction="row" spacing={2} alignItems="baseline">
                                                {
                                                    item.icon &&
                                                    <MprcText color={item.iconColor ?? "inherit"}>
                                                        <FontAwesomeIcon fontSize={size === "small" ? 15 : 20} icon={item.icon} />
                                                    </MprcText>
                                                }
                                                <Stack direction="column">
                                                    <Box>
                                                        {
                                                            item.title && disableTypography
                                                                ? item.title
                                                                : item.title
                                                                    ? <Typography variant="overline">{item.title}</Typography>
                                                                    : null
                                                        }

                                                        {
                                                            item.text && disableTypography
                                                                ? item.text
                                                                : item.text
                                                                    ? <Typography variant={size === "small" ? "caption" : "h6"} color="muted.main" lineHeight={1.4}>
                                                                        {item.text}
                                                                    </Typography>
                                                                    : null
                                                        }
                                                    </Box>
                                                    {item.action &&
                                                        <CardActions sx={{ pl: 0 }}>
                                                            {item.action}
                                                        </CardActions>
                                                    }
                                                </Stack>
                                            </Stack>
                                        </MprcContainer>
                                )
                            }
                        </Box>
                    </MprcCard>
                </MprcContainer>
            }
        </>
    );
};
